import type { BriefSection } from '../../types/canvas';
import type { GenerateStreamStatus } from '../../lib/use-generate-stream';

interface BriefHeaderProps {
  sections: BriefSection[];
  streamStatus?: GenerateStreamStatus;
  totalExpected?: number;
  onPress?: () => void;
}

export function BriefHeader({ sections, streamStatus, totalExpected = 16, onPress }: BriefHeaderProps) {
  const approved = sections.filter((s) => s.status === 'approved').length;
  const total = sections.length;
  const isStreaming = streamStatus === 'streaming' || streamStatus === 'connecting';
  const ready = !isStreaming && total >= totalExpected && approved === total;

  let statusText: string;
  let statusColor: string;
  if (isStreaming) {
    statusText = `Brief generating · ${total}/${totalExpected}`;
    statusColor = 'text-muted-foreground';
  } else if (ready) {
    statusText = `Brief ready · ${total}/${totalExpected}`;
    statusColor = 'text-success';
  } else {
    statusText = `${approved}/${total} approved`;
    statusColor = 'text-muted-foreground';
  }

  return (
    <header className="flex items-center justify-between px-5 sm:px-8 py-3.5 border-b border-border sticky top-0 bg-background z-50">
      <a href="/" className="font-display text-[17px] text-foreground flex items-center gap-2">
        <span className="w-[7px] h-[7px] rounded-full bg-primary inline-block" aria-hidden="true" />
        Ghostwright
      </a>
      <div className="flex items-center gap-3.5">
        <span className={`text-xs font-medium ${statusColor}`}>
          {statusText}
        </span>
        <button
          onClick={onPress}
          disabled={!ready}
          className="py-2 px-5 bg-primary text-white border-none rounded-md font-body text-xs font-semibold cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Press My Book
        </button>
      </div>
    </header>
  );
}
